import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/coupons/[slug]/CouponsClient.tsx");
